<app-new-modal-body>
    @if (form) {
        <form [formGroup]="form" (ngSubmit)="submit()" class="tw:p-4 tw:text-center">
            <app-icon icon="warning" extraClass="tw:mb-2 tw:!text-warning-500 tw:!text-4xl" />
    
            @if (data.saleStatus === ISaleStatus.DRAFT) {
                <h6 class="tw:h6 tw:mb-6 tw:w-full tw:text-center tw:text-warning-500">{{ 'SALES_LIST_PAGE.deleteDraft' | translate }}</h6>
                <div class="tw:mb-6 tw:w-full tw:text-center">{{ 'SALES_LIST_PAGE.deleteDraftConfirm' | translate }}</div>
            } @else if (isInvoicingActive()) {
                <h6 class="tw:h6 tw:mb-6 tw:w-full tw:text-center tw:text-warning-500">{{ "CANCEL_INVOICE_MODAL.titleInvoice" | translate }}</h6>
                <div class="tw:mb-6 tw:w-full tw:text-center">{{ "CANCEL_INVOICE_MODAL.descriptionInvoice" | translate }}</div>
            } @else {
                <h6 class="tw:h6 tw:mb-6 tw:w-full tw:text-center tw:text-warning-500">{{ "CANCEL_INVOICE_MODAL.title" | translate }}</h6>
                <div class="tw:mb-6 tw:w-full tw:text-center">{{ "CANCEL_INVOICE_MODAL.description" | translate }}</div>
            }
    
    
            @if (data.saleStatus !== ISaleStatus.DRAFT) {
                <div class="tw:text-left">
                    <app-text-input formControlName="reason"
                        [label]="'CANCEL_INVOICE_MODAL.reasonLabel' | translate"
                        [placeholder]="'CANCEL_INVOICE_MODAL.reasonPlaceholder' | translate"
                        [submitAttempted]="submitAttempted()" />
                </div>

                @if (data?.hasPayments) {
                    <div class="tw:text-left tw:mb-4">
                        <app-dropdown-input-v2 formControlName="refundPaymentMethod"
                            [label]="'CANCEL_INVOICE_MODAL.refundPaymentMethodLabel' | translate"
                            invalidMsg="{{ 'CANCEL_INVOICE_MODAL.refundPaymentMethodRequired' | translate }}"
                            [placeholder]="'CANCEL_INVOICE_MODAL.refundPaymentMethodPlaceholder' | translate"
                            [options]="paymentMethods"
                            textOption="label"
                            [submitAttempted]="submitAttempted()" />
                    </div>

                    <app-alert type="warning" msg="{{ 'CANCEL_INVOICE_MODAL.paymentsWarning' | translate }}" />
                }
            }
    
            <app-button buttonType="submit" [loading]="saving()" extraClass="tw:w-full tw:!mb-4">
                @if (data.saleStatus === ISaleStatus.DRAFT) {
                    {{ 'SALES_LIST_PAGE.deleteDraft' | translate }}
                } @else if (isInvoicingActive()) {
                    {{ "CANCEL_INVOICE_MODAL.titleInvoice" | translate }}
                } @else {
                    {{ "CANCEL_INVOICE_MODAL.title" | translate }}
                }
            </app-button>
    
            <app-button type="secondary" (clickEvent)="close()" extraClass="tw:w-full"> {{ "CANCEL_INVOICE_MODAL.cancel" | translate }} </app-button>
        </form>
    }
</app-new-modal-body>